function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Drawer, message, Tree, Modal, Table, Tabs, notification } from 'antd';
import { NodePlusFill, XSquareFill, ArrowClockwise, TrashFill, Diagram3Fill, PencilFill, CartPlusFill, PersonPlus, FilePostFill, EyeFill, PlusCircleFill, PlusSquare, PencilSquare } from 'react-bootstrap-icons';
import Common from "../components/includes/Common";
import AddTemplateReport from "../components/forms/AddReportTemplate";
import EditReportTemplate from "../components/forms/EditReportTemplate";
import AddPrescriber from "../components/forms/AddPrescriber";
import EditPrescriber from "../components/forms/EditPrescriber";
import EditBusinessAccountItem from "../components/forms/EditBusinessAccountItem";
import AddBusinessAccountItem from "../components/forms/AddBusinessAccountItem";
import AddSubCategory from "../components/forms/AddSubCategory";
import EditSubCategory from "../components/forms/EditSubCategory";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Departments = function Departments() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewCategoryVisible = _useState2[0],
    setIsNewCategoryVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNewItemFormVisible = _useState4[0],
    setIsNewItemFormVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataChanged = _useState6[0],
    setDataChanged = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dataChangedRt = _useState8[0],
    setDataChangedRt = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    dataChangedPr = _useState0[0],
    setDataChangedPr = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedItem = _useState10[0],
    setSelectedItem = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    itemViewVisible = _useState12[0],
    setItemViewVisible = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    itemEditVisible = _useState14[0],
    setItemEditVisible = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    itemsArray = _useState16[0],
    setItemsArray = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    isDataLoading = _useState18[0],
    setIsDataLoading = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showAddReportTemplate = _useState20[0],
    setShowAddReportTemplate = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showEditReportTemplate = _useState22[0],
    setShowEditReportTemplate = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    templates = _useState24[0],
    setTemplates = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    selectedRt = _useState26[0],
    setSelectedRt = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    selectedPrescriber = _useState28[0],
    setSelectedPrescriber = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showAddPrescriber = _useState30[0],
    setShowAddPrescriber = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showEditPresciber = _useState32[0],
    setShowEditPrescriber = _useState32[1];
  var _useState33 = useState([]),
    _useState34 = _slicedToArray(_useState33, 2),
    prescribers = _useState34[0],
    setPrescribers = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    isInitLoading = _useState36[0],
    setIsInitLoading = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    catsArray = _useState38[0],
    setCatsArray = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    showEditSubCategory = _useState40[0],
    setShowEditSubCategory = _useState40[1];
  var _useState41 = useState(null),
    _useState42 = _slicedToArray(_useState41, 2),
    selectedSubCategory = _useState42[0],
    setSelectedSubCategory = _useState42[1];
  var pcols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Nom"
    }),
    dataIndex: "name",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Mobible"
    }),
    dataIndex: "mobile",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "mobile"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Balance"
    }),
    dataIndex: "balance",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "mobile"
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: "action",
    render: function render(p) {
      return /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setSelectedPrescriber(p);
              setShowEditPrescriber(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(PencilSquare, {
                size: 22
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              handleDeletePrescriber(p);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(TrashFill, {
                size: 22
              })
            })
          })]
        })
      });
    },
    key: "description"
  }];
  var catCols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9signation"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9partment"
    }),
    dataIndex: "department",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "department"
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: "action",
    render: function render(p) {
      return /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setSelectedSubCategory(p);
              setShowEditSubCategory(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(PencilSquare, {
                size: 22
              })
            })
          }), contextHolder, /*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setSelectedSubCategory(p);
              confirm({
                title: /*#__PURE__*/_jsx("b", {
                  children: "Confirmez-vous ?"
                }),
                content: /*#__PURE__*/_jsxs("p", {
                  children: ["La suppression de l'\xE9lement ", p.label]
                }),
                type: "warning",
                onOk: function onOk() {},
                onCancel: function onCancel() {
                  setIsDataLoading(false);
                }
              });
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(TrashFill, {
                size: 22
              })
            })
          })]
        })
      });
    },
    key: "action"
  }];
  var rtCols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Titre"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Desc."
    }),
    dataIndex: "description",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "description"
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: "action",
    render: function render(t) {
      return /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setSelectedRt(t);
              setShowEditReportTemplate(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(PencilSquare, {
                size: 22
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              handleDeleteRt(t);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(TrashFill, {
                size: 22
              })
            })
          })]
        })
      });
    },
    key: "description"
  }];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Acte/Service"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Service"
    }),
    dataIndex: "category",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "category"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Sous-Service"
    }),
    dataIndex: "subCategory",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "subCategory"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tarif part."
    }),
    dataIndex: "base_price",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "base_price"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tarif soc."
    }),
    dataIndex: "ent_price",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "ent_price"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tarif assur."
    }),
    dataIndex: "ins_price",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "ins_price"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Actions"
    }),
    dataIndex: "action",
    render: function render(item) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleEditItem(item);
          },
          children: /*#__PURE__*/_jsx(PencilFill, {
            size: 20
          })
        }), contextHolder, /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleDeleteItem(item);
          },
          children: /*#__PURE__*/_jsx(TrashFill, {
            size: 20
          })
        })]
      });
    },
    key: "action"
  }];
  var handleDeleteRt = function handleDeleteRt(t) {
    setSelectedRt(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du compte rendu type - ", t.label, " ?"]
      }),
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deletereporttemplate/" + Common.currentUser.id + "/" + t.id.toString()).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  var handleDeletePrescriber = function handleDeletePrescriber(p) {
    setSelectedRt(p);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du medecin prescripteur - ", p.name, " ?"]
      }),
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deleteprescriber/" + Common.currentUser.id + "/" + p.id.toString()).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  var handleEditItem = function handleEditItem(item) {
    setSelectedItem(item);
    setItemEditVisible(true);
  };
  var handleDeleteItem = function handleDeleteItem(item) {
    setSelectedItem(item);
    confirm({
      title: "Confirmez-vous ?",
      content: "La suppression de " + item.label,
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deletebusinessaccountitem/" + selectedItem.key.toString() + "/" + Common.currentUser.id.toString()).then(function (response) {
          if (response.status == 200) {
            setDataChanged(true);
            message.success({
              content: response.data.message,
              delay: 4
            });
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };
  var tabItems = [{
    key: 1,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CartPlusFill, {
        size: 23
      }), " Articles"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsxs(Button, {
                type: "primary",
                style: {
                  width: '98%'
                },
                icon: /*#__PURE__*/_jsx(NodePlusFill, {
                  size: 26
                }),
                onClick: function onClick() {
                  setIsNewItemFormVisible(true);
                },
                children: [" ", /*#__PURE__*/_jsx("b", {
                  children: "Ajouter un article"
                })]
              }), /*#__PURE__*/_jsxs(Button, {
                type: "primary",
                style: {
                  width: '98%',
                  background: "#8B6E62"
                },
                icon: /*#__PURE__*/_jsx(NodePlusFill, {
                  size: 26
                }),
                onClick: function onClick() {
                  setIsNewCategoryVisible(true);
                },
                children: [" ", /*#__PURE__*/_jsx("b", {
                  children: "Ajouter une sous-cat\xE9gorie"
                })]
              }), contextHolder, /*#__PURE__*/_jsxs(Button, {
                disabled: true,
                loading: isInitLoading,
                onClick: function onClick() {
                  setIsInitLoading(true);
                  confirm({
                    title: /*#__PURE__*/_jsx("b", {
                      children: "Veuillez confimer"
                    }),
                    content: /*#__PURE__*/_jsx("p", {
                      children: "L'initialisation de tous les articles et prix aux valeurs par d\xE9faut"
                    }),
                    onOk: function onOk() {
                      axios.get(Common.baseApiUrl + "inititems/" + Common.currentUser.id).then(function (response) {
                        if (response.data.status == 200) {
                          setDataChanged(true);
                          notification.success({
                            message: "Ok !",
                            description: response.data.message
                          });
                        } else {
                          notification.error({
                            message: "Oops!",
                            description: response.data.message
                          });
                        }
                      })["catch"](function (error) {
                        notification.error({
                          message: "Oops!",
                          description: "Une erreur est survenue"
                        });
                      })["finally"](function () {
                        setIsInitLoading(false);
                      });
                    },
                    onCancel: function onCancel() {
                      setIsInitLoading(false);
                    }
                  });
                },
                color: "#fff",
                variant: "outlined",
                icon: /*#__PURE__*/_jsx(ArrowClockwise, {
                  size: 26
                }),
                children: [" ", /*#__PURE__*/_jsx("b", {
                  children: "Charger par d\xE9faut"
                })]
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              className: "white-bg cool-radius",
              children: /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: cols,
                bordered: true,
                sticky: false,
                loading: isDataLoading,
                dataSource: itemsArray,
                pagination: true
              })
            })]
          })
        })
      })
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Diagram3Fill, {
        size: 23
      }), " Sous-service"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Space, {
              direction: "horizontal",
              children: /*#__PURE__*/_jsxs(Button, {
                type: "primary",
                style: {
                  width: '98%',
                  background: "#8B6E62"
                },
                icon: /*#__PURE__*/_jsx(NodePlusFill, {
                  size: 26
                }),
                onClick: function onClick() {
                  setIsNewCategoryVisible(true);
                },
                children: [" ", /*#__PURE__*/_jsx("b", {
                  children: "Ajouter une sous-cat\xE9gorie"
                })]
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              className: "white-bg cool-radius",
              children: /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: catCols,
                bordered: true,
                sticky: false,
                loading: isDataLoading,
                dataSource: catsArray,
                pagination: true
              })
            })]
          })
        })
      })
    })
  }, {
    key: 3,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(FilePostFill, {
        size: 23
      }), " Comptes rendu type"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setShowAddReportTemplate(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(PlusSquare, {
                    size: 22
                  })
                })
              }), contextHolder, /*#__PURE__*/_jsxs(Button, {
                loading: isInitLoading,
                onClick: function onClick() {
                  setIsInitLoading(true);
                  confirm({
                    title: /*#__PURE__*/_jsx("b", {
                      children: "Veuillez confimer"
                    }),
                    content: /*#__PURE__*/_jsx("p", {
                      children: "L'initialisation de tous les mod\xE8les de comptes rendu aux valeurs par d\xE9faut"
                    }),
                    onOk: function onOk() {
                      axios.get(Common.baseApiUrl + "initreporttemplates/" + Common.currentUser.id).then(function (response) {
                        if (response.data.status == 200) {
                          setDataChangedRt(true);
                          notification.success({
                            message: "Ok !",
                            description: response.data.message
                          });
                        } else {
                          notification.error({
                            message: "Oops!",
                            description: response.data.message
                          });
                        }
                      })["catch"](function (error) {
                        notification.error({
                          message: "Oops!",
                          description: "Une erreur est survenue"
                        });
                      })["finally"](function () {
                        setIsInitLoading(false);
                      });
                    },
                    onCancel: function onCancel() {
                      setIsInitLoading(false);
                    }
                  });
                },
                color: "#fff",
                variant: "outlined",
                icon: /*#__PURE__*/_jsx(ArrowClockwise, {
                  size: 26
                }),
                children: [" ", /*#__PURE__*/_jsx("b", {
                  children: "Charger par d\xE9faut"
                })]
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: rtCols,
                bordered: true,
                sticky: false,
                loading: isDataLoading,
                dataSource: templates,
                pagination: true
              })
            })]
          })
        })
      })
    })
  }, {
    key: 4,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(PersonPlus, {
        size: 23
      }), " Medecins Prescripteurs"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Button, {
              type: "default",
              onClick: function onClick() {
                setShowAddPrescriber(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(PlusSquare, {
                  size: 22
                })
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: pcols,
                bordered: true,
                sticky: false,
                loading: isDataLoading,
                dataSource: prescribers,
                pagination: true
              })
            })]
          })
        })
      })
    })
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getbusinessaccountitems/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setItemsArray([]);
        response.data.products.forEach(function (s) {
          setItemsArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: s.id.toString() + "tab",
              label: s.label,
              category: s.department != null ? s.department.label : "NA",
              subCategory: s.business_account_medical_item_category != null ? s.business_account_medical_item_category.label : "AUTRES",
              base_price: s.base_price,
              ent_price: s.ent_price,
              ins_price: s.ins_price,
              action: s
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getreporttemplates/" + Common.currentUser.id).then(function (response) {
      setTemplates([]);
      if (response.data.status == 200) {
        response.data.templates.forEach(function (e) {
          setTemplates(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: e.label,
              description: e.description,
              content: e.content,
              action: e
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setDataChangedRt(false);
    });
  }, [dataChangedRt]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getprescribers/" + Common.currentUser.id).then(function (response) {
      setPrescribers([]);
      if (response.data.status == 200) {
        response.data.prescribers.forEach(function (p) {
          setPrescribers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              name: p.name,
              mobile: p.mobile,
              balance: p.balance,
              action: p
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setDataChangedPr(false);
    });
  }, [dataChangedPr]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getbusinessaccountmedicalitemcategories/" + Common.currentUser.id).then(function (response) {
      setCatsArray([]);
      if (response.data.status == 200) {
        response.data.categories.forEach(function (c) {
          setCatsArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              department: c.department && c.department.label,
              action: c
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setDataChangedPr(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Tabs, {
        items: tabItems,
        animated: true
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewItemFormVisible,
      width: 400,
      destroyOnClose: true,
      title: "Ajouter un acte/examen",
      onClose: function onClose() {
        setIsNewItemFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(AddBusinessAccountItem, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: itemEditVisible,
      destroyOnClose: true,
      width: 400,
      title: /*#__PURE__*/_jsx("b", {
        children: "Modifier un acte"
      }),
      onCancel: function onCancel() {
        setItemEditVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(EditBusinessAccountItem, {
        handler: function handler() {
          setDataChanged(true), setItemEditVisible(false);
          message.success({
            content: "Modifications enregistrées",
            delay: 4
          });
        },
        item: selectedItem
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: isNewCategoryVisible,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "Nouvelle sous-cat\xE9gorie"
      }),
      onCancel: function onCancel() {
        setIsNewCategoryVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(AddSubCategory, {
        handler: function handler() {
          setDataChanged(true), setIsNewCategoryVisible(false);
          notification.success({
            message: "Ok!",
            description: "Modifications enregistrées",
            delay: 4
          });
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddReportTemplate,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "NOUVEAU COMPTE RENDU TYPE"
      }),
      onClose: function onClose() {
        setShowAddReportTemplate(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(AddTemplateReport, {
        handler: function handler() {
          setDataChangedRt(true);
          setShowAddReportTemplate(false);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddPrescriber,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UN PRESCRIPTEUR"
      }),
      onClose: function onClose() {
        setShowAddPrescriber(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(AddPrescriber, {
        handler: function handler() {
          setDataChangedPr(true);
          setShowAddPrescriber(false);
        }
      })
    }), selectedRt && /*#__PURE__*/_jsx(Drawer, {
      open: showEditReportTemplate,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LE COMPTE RENDU TYPE"
      }),
      onClose: function onClose() {
        setShowEditReportTemplate(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(EditReportTemplate, {
        template: selectedRt,
        handler: function handler() {
          setDataChangedRt(true);
          setShowEditReportTemplate(false);
        }
      })
    }), selectedPrescriber && /*#__PURE__*/_jsx(Drawer, {
      open: showEditPresciber,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LE PRESCRIPTEUR"
      }),
      onClose: function onClose() {
        setShowEditPrescriber(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(EditPrescriber, {
        prescriber: selectedPrescriber,
        handler: function handler() {
          setDataChangedPr(true);
          setShowEditPrescriber(false);
        }
      })
    }), selectedSubCategory && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        open: showEditSubCategory,
        destroyOnClose: true,
        title: /*#__PURE__*/_jsx("b", {
          children: "Modifier le sous-service"
        }),
        onCancel: function onCancel() {
          setShowEditSubCategory(false);
        },
        footer: null,
        closable: true,
        children: /*#__PURE__*/_jsx(EditSubCategory, {
          category: selectedSubCategory,
          handler: function handler() {
            setDataChanged(true), setShowEditSubCategory(false);
            notification.success({
              message: "Ok!",
              description: "Modifications enregistrées",
              delay: 4
            });
          }
        })
      })
    })]
  });
};
export default Departments;